(() => {
  const initRoot = (root) => {
    if (!root || root.dataset.boxicaReady === 'true') return;
    root.dataset.boxicaReady = 'true';

    /* Shopify can retain theme-group sections when a theme is imported. */
    document.body.classList.add('boxica-premium-template');
    if (root.classList.contains('bxp-home')) document.body.classList.add('boxica-premium-home-template');
    document.querySelectorAll(
      '.shopify-section-group-header-group, .section-header, .announcement-bar-section, [id$="__blocks_trust_badges"], .footer-block--newsletter, .footer__payment'
    ).forEach((element) => {
      if (!element.closest('[data-boxica-premium]')) {
        element.style.setProperty('display', 'none', 'important');
      }
    });

    root.querySelectorAll('[data-bx-gallery]').forEach((gallery) => {
      const panels = [...gallery.querySelectorAll('[data-bx-media]')];
      const thumbs = [...gallery.querySelectorAll('[data-bx-thumb]')];
      gallery.classList.add('is-ready');

      const activate = (index) => {
        panels.forEach((panel, panelIndex) => {
          const active = panelIndex === index;
          panel.classList.toggle('is-active', active);
          const video = panel.querySelector('video');
          if (!video) return;
          if (active) {
            video.muted = true;
            const playPromise = video.play();
            if (playPromise && typeof playPromise.catch === 'function') playPromise.catch(() => {});
          } else {
            video.pause();
          }
        });
        thumbs.forEach((thumb, thumbIndex) => {
          const active = thumbIndex === index;
          thumb.classList.toggle('is-active', active);
          thumb.setAttribute('aria-selected', active ? 'true' : 'false');
        });
      };

      thumbs.forEach((thumb, index) => thumb.addEventListener('click', () => activate(index)));
      activate(0);
    });

    root.querySelectorAll('[data-bx-quantity]').forEach((quantity) => {
      const input = quantity.querySelector('input[name="quantity"]');
      if (!input) return;
      quantity.querySelector('[data-bx-minus]')?.addEventListener('click', () => {
        input.value = String(Math.max(Number(input.min || 1), Number(input.value || 1) - 1));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
      quantity.querySelector('[data-bx-plus]')?.addEventListener('click', () => {
        input.value = String(Number(input.value || 1) + 1);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });

    root.querySelectorAll('[data-bx-review-toggle]').forEach((button) => {
      const grid = root.querySelector('[data-bx-review-grid]');
      if (!grid) return;
      button.addEventListener('click', () => {
        const expanded = button.getAttribute('aria-expanded') === 'true';
        button.setAttribute('aria-expanded', expanded ? 'false' : 'true');
        grid.classList.toggle('is-expanded', !expanded);
        if (grid.hasAttribute('data-bx-judge-panel')) grid.hidden = expanded;
        const label = button.querySelector('[data-bx-review-label]');
        if (label) label.textContent = expanded ? 'Prikaži sva iskustva' : 'Prikaži manje';
      });
    });

    const premiumHeader = root.querySelector('[data-bx-header]');
    if (premiumHeader) {
      const syncHeader = () => premiumHeader.classList.toggle('is-scrolled', window.scrollY > 48);
      syncHeader();
      window.addEventListener('scroll', syncHeader, { passive: true });
    }

    root.querySelectorAll('[data-bx-sound]').forEach((button) => {
      const video = button.closest('.bx-video-frame')?.querySelector('video');
      if (!video) return;
      button.addEventListener('click', async () => {
        video.muted = !video.muted;
        if (video.paused) {
          try { await video.play(); } catch (_) {}
        }
        button.setAttribute('aria-pressed', video.muted ? 'false' : 'true');
        const label = button.querySelector('b');
        if (label) label.textContent = video.muted ? 'Uključi zvuk' : 'Isključi zvuk';
      });
    });

    root.querySelectorAll('[data-bx-cookie-preferences]').forEach((button) => {
      button.addEventListener('click', () => {
        if (window.Shopify?.customerPrivacy?.showPreferences) {
          window.Shopify.customerPrivacy.showPreferences();
        } else {
          document.dispatchEvent(new CustomEvent('shopify:show-customer-privacy-preferences'));
        }
      });
    });

        root.querySelectorAll('a[href="#bx-written-complaint"]').forEach((link) => {
      link.addEventListener('click', () => {
        const complaint = document.querySelector(
          '#bx-written-complaint .bx-complaint'
        );
        if (complaint) complaint.open = true;
      });
    });
    root.querySelectorAll('[data-bx-review-open]').forEach((button) => {
      button.addEventListener('click', () => {
        const dialog = document.getElementById(button.dataset.bxReviewOpen);
        if (!dialog) return;
        if (typeof dialog.showModal === 'function') dialog.showModal();
        else dialog.setAttribute('open', '');
      });
    });

    root.querySelectorAll('[data-bx-review-dialog]').forEach((dialog) => {
      const close = () => {
        if (typeof dialog.close === 'function') dialog.close();
        else dialog.removeAttribute('open');
      };
      dialog.querySelector('[data-bx-review-close]')?.addEventListener('click', close);
      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) close();
      });
      if (dialog.querySelector('.bx-review-success')) {
        window.setTimeout(() => {
          if (typeof dialog.showModal === 'function' && !dialog.open) dialog.showModal();
          else dialog.setAttribute('open', '');
        }, 120);
      }
    });

    root.querySelectorAll('[data-bx-language-select]').forEach((select) => {
      select.addEventListener('change', () => {
        try { window.localStorage.setItem('bx-language-choice', select.value); } catch (_) {}
        select.form?.submit();
      });
    });

    const cartButtons = [...root.querySelectorAll('[data-bx-add-to-cart]')];
    if (cartButtons.length) {
      const defaultMarkup = new Map(cartButtons.map((button) => [button, button.innerHTML]));
      const variantId = Number(root.dataset.bxVariantId);
      const promoCode = root.dataset.bxPromoCode || 'STELA';
      const productUrl = root.dataset.bxProductUrl || '/products/glowlift-pro-by-boxica';
      let isAdding = false;

      const setBusy = (busy, message) => {
        cartButtons.forEach((button) => {
          const unavailable = button.hasAttribute('aria-disabled');
          button.disabled = busy || unavailable;
          button.setAttribute('aria-busy', busy ? 'true' : 'false');
          if (message) button.textContent = message;
          if (!busy && !message && defaultMarkup.has(button)) {
            button.innerHTML = defaultMarkup.get(button);
          }
        });
      };

      cartButtons.forEach((button) => {
        button.addEventListener('click', async () => {
          if (isAdding || button.disabled) return;
          if (!variantId) {
            window.location.assign(productUrl);
            return;
          }

          isAdding = true;
          setBusy(true, 'Dodajem…');

          try {
            const rootUrl = window.Shopify?.routes?.root || '/';
            const response = await fetch(`${rootUrl}cart/add.js`, {
              method: 'POST',
              credentials: 'same-origin',
              headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
              },
              body: JSON.stringify({
                items: [{ id: variantId, quantity: 1 }]
              })
            });

            if (!response.ok) throw new Error('Dodavanje u košaricu nije uspjelo.');

            const discountPath = `/discount/${encodeURIComponent(promoCode)}?redirect=${encodeURIComponent('/checkout')}`;
            window.location.assign(discountPath);
          } catch (_) {
            isAdding = false;
            setBusy(false, 'Pokušajte ponovno');
            window.setTimeout(() => setBusy(false, ''), 2400);
          }
        });
      });
    }

    const hero = root.querySelector('[data-bx-sticky-sentinel]');
    const sticky = root.querySelector('[data-bx-sticky]');
    if (hero && sticky) {
      const isHome = root.classList.contains('bxp-home');
      const syncSticky = () => {
        const mobileHomeThreshold = 72;
        const threshold = isHome && window.matchMedia('(max-width: 749px)').matches
          ? mobileHomeThreshold
          : hero.offsetTop + hero.offsetHeight * .72;
        sticky.classList.toggle('is-visible', window.scrollY > threshold);
      };
      syncSticky();
      window.addEventListener('scroll', syncSticky, { passive: true });
      window.addEventListener('resize', syncSticky, { passive: true });
    }
  };

  const initAutomaticCroatian = () => {
    const container = document.querySelector('[data-bx-auto-locale]');
    const form = container?.querySelector('form');
    if (!form || window.Shopify?.designMode) return;
    const countryIsCroatia = container.dataset.bxCountry === 'HR';
    const browserUsesCroatian = (window.navigator.language || '').toLowerCase().startsWith('hr');
    if (!countryIsCroatia && !browserUsesCroatian) return;
    try {
      if (window.localStorage.getItem('bx-language-choice')) return;
      if (window.sessionStorage.getItem('bx-auto-hr-attempted')) return;
      window.sessionStorage.setItem('bx-auto-hr-attempted', 'true');
    } catch (_) {}
    form.submit();
  };

  const initAll = () => {
    document.querySelectorAll('[data-boxica-premium]').forEach(initRoot);
    initAutomaticCroatian();
  };
  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', initAll);
})();
